import { render, staticRenderFns } from "./appbarprofileavatar-component.vue?vue&type=template&id=fe561156"
import script from "./appbarprofileavatar-component.vue?vue&type=script&lang=ts"
export * from "./appbarprofileavatar-component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports